<template>
     <el-row>
      <el-col :span="18" :xs="24" style="border: 1px solid #ccc; box-sizing: border-box;">
        <!-- 第一列 -->
        <el-card class="mb-4">
          <div style="display: flex; align-items: center;">
            <div class="content-wrapper">
              <div class="left-content">
                <h3>项目动态评价</h3>
                <div class="no-rating-badge">暂无评级</div>
              </div>
              <el-divider direction="vertical"  style="height:200px;" />
              <div class="right-content">
                <h3>项目评级历史动态</h3>
                <span>暂无项目评级历史动态</span>
              </div>
            </div>
          </div>
        </el-card>
        <el-card class="mb-4">
          <h3>项目评级历史动态</h3>
          <p>暂无项目评级历史动态</p>
        </el-card>
        <el-card class="mb-4">
          <h3>分账管理制度落实情况</h3>
          <p>专户银行: 中国银行</p>
          <p>专户名称: 广东腾越环卫有限公司</p>
          <p>专户账号: 1797****3928</p>
          <p>签约状态: 已签约</p>
          <p>专户缴存总额(万元): 17,085.64</p>
          <p>专户缴存余额(万元): 2.21</p>
          <p>专户应缴金额(万元): 8,469.41</p>
        </el-card>
        <el-card class="mb-4">
          <h3>实名制管理制度落实情况</h3>
          <p>实名制总人数: 5878人</p>
          <p>本月新增人数: 17人</p>
          <p>总考勤数: 1479906次</p>
          <p>本月考勤量: 16279次</p>
          <p>实名制合同签订比例: 97%</p>
          <p>实名制考勤比例: 100%</p>
        </el-card>
        <el-card class="mb-4">
          <h3>今日考勤概况</h3>
          <p>项目在勤人数: 1143人</p>
          <p>今日出勤人数: 114人</p>
          <p>出勤率: 10%</p>
        </el-card>
        <el-card class="mb-4">
          <h3>工资代发制度落实情况</h3>
          <el-row>
            <el-col :span="6" class="col-style">
              <el-row>
                <el-col :span="24" class="col-inner-style">
                  <p>代发总金额</p>
                  <p style="color: blue;">12302.82万元</p>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24" class="col-inner-style">
                  <p>按月工资代发比例</p>
                  <p style="color: blue;">0%</p>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6" class="col-style">
              <el-row>
                <el-col :span="24" class="col-inner-style">
                  <p>代发总人次</p>
                  <p style="color: blue;">13076人</p>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24" class="col-inner-style">
                  <p>工资确认比例(工资表附件)</p>
                  <p style="color: blue;">73%</p>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6" class="col-style">
              <el-row>
                <el-col :span="24" class="col-style">
                  <p>本月实发金额</p>
                  <p style="color: blue;">58.66万元</p>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24" class="col-style">
                  <p>工资确认比例(手机app)</p>
                  <p style="color: blue;">0%</p>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="6" :xs="24" style="border: 1px solid #ccc; box-sizing: border-box;">
        <!-- 第二列 -->
        <el-card class="mb-4">
          <h3>待处理预警</h3>
          <p>2024年12月1日 未上传银行回执单预警 未处理</p>
          <p>2024年12月1日 未上传银行回执单预警 未处理</p>
          <p>2024年12月1日 未上传银行回执单预警 未处理</p>
          <p>2024年11月1日 出勤人员未发放工资... 未处理</p>
        </el-card>
        <el-card class="mb-4">
          <h3>项目基本信息</h3>
          <p>环卫企业: 滁州苏宁置业有限公司</p>
          <p>业主单位: 腾越建筑科技集团有限公司</p>
          <p>投资类型: 非政府投资</p>
          <p>所属行业: 住建</p>
          <p>工程造价: 919613921.6元</p>
          <p>项目地址: 滁州市滁州市中都大道道路</p>
          <p>项目负责人: 冯达明</p>
          <p>联系方式: 18675363789</p>
          <p>项目经理: 王亮</p>
          <p>联系方式: 18986072049</p>
          <el-button type="text">查看项目详情 >></el-button>
        </el-card>
        <el-card class="mb-4">
          <h3>工伤保险信息</h3>
          <p>首次参保</p>
          <p>参保时间: 2021-07-08</p>
          <p>参保单位: 广东腾越环卫有限公司</p>
          <p>投保单位: 滁州市市辖区人社局</p>
          <p>参保人数: 4911</p>
        </el-card>
      </el-col>
    </el-row>
</template>

<script setup>
import { ref } from 'vue';
import { ArrowLeftBold } from '@element-plus/icons-vue';
import { useRoute, useRouter } from 'vue-router';
// 项目基本信息
const projectName = 'SN广场南侧地块一标段、二标段总承包工程';
const projectEstablishDate = '2021-07-02';
const projectStartDate = '2021-06-18';
const projectDuration = 1074;
const projectOverdue = 214;
const projectResource = "市监察";

// 项目动态评价相关
const rating = false;
const ratingHistory = false;

// 分账管理数据
const accountData = [
  {
    bank: '中国银行',
    totalDeposit: 17085.64,
    depositBalance: 2.21,
    shouldPay: 8469.41
  }
];

// 待处理预警数据
const warningData = [
  {
    date: '2024-12-01',
    warning: '出勤人员未发放工资...',
    status: '未处理'
  },
  {
    date: '2024-12-01',
    warning: '未上传银行回执单预警',
    status: '未处理'
  },
  {
    date: '2024-12-01',
    warning: '未上传银行回执单预警',
    status: '未处理'
  },
  {
    date: '2024-12-01',
    warning: '未上传银行回执单预警',
    status: '未处理'
  },
  {
    date: '2024-11-01',
    warning: '出勤人员未发放工资...',
    status: '未处理'
  }
];

// 项目基本信息
const constructionParty = '滁州苏宁置业有限公司';
const constructionCompany = '腾越建筑科技集团有限公司';
const investmentType = '非政府投资';
const industry = '房地产';

// Tabs相关
const activeTab = ref('项目看板');

// 项目基本信息修改方法
const editProjectInfo = () => {
  // 这里可以添加跳转到修改页面或弹出修改对话框的逻辑
  console.log('跳转到项目基本信息修改页面');
};

const route = useRoute();
const router = useRouter();
const goBack = () => {
  router.go(-1);
};
</script>

<style scoped>
.project-overview {
  margin-bottom: 20px;
}
.mb-4 {
  margin-bottom: 16px;
}

.col-style {
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  margin: 5px;
  padding: 10px;
}
.col-inner-style {
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  margin: 5px;
  padding: 10px;
}

.content-wrapper {
  display: flex;
  justify-content: space-between;
}
.left-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.no-rating-badge {
  border: 1px solid #ccc;
  border-radius: 50%;
  padding: 10px;
  text-align: center;
}
.right-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

</style>

